import React from "react";
import { PageBuilderOpeningTextFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import PageBuilderButtonCTA from "./PageBuilderButtonCTA";
import {
  ButtonsContainer,
  OpeningText,
  OpeningTextBody,
  OpeningTextHeading,
  OpeningTextSubHeading
} from "@silversea-ssc/ui-components-react";
import TextBox from "components/TextBox/TextBox";

type Props = PageBuilderOpeningTextFragment;

const PageBuilderOpeningText: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  subtitle,
  content,
  ctaButtons
}) => {
  return (
    <OpeningText>
      {title && <OpeningTextHeading>{title.localized}</OpeningTextHeading>}
      {subtitle && (
        <OpeningTextSubHeading>{subtitle.localized}</OpeningTextSubHeading>
      )}
      {content && (
        <OpeningTextBody>
          <TextBox fontSize="medium" content={content.localized} />
          {ctaButtons && ctaButtons.length > 0 && (
            <ButtonsContainer spacingTop="regular">
              {ctaButtons.map((button) => (
                <PageBuilderButtonCTA key={button?._key} {...button} />
              ))}
            </ButtonsContainer>
          )}
        </OpeningTextBody>
      )}
    </OpeningText>
  );
};

export default PageBuilderOpeningText;

export const fragments = graphql`
  fragment PageBuilderOpeningText on SanityOpeningText {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    title {
      localized
    }
    subtitle {
      localized
    }
    content {
      localized
    }
    ctaButtons {
      ...ButtonCTA
    }
  }
`;
